import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import { AddBlockToViewToJSON, BlockFromJSON, ReplaceBlockParametersPayloadToJSON, UpdateBlockInViewToJSON } from '../models/index';

/**
 * BlocksApi - interface
 * 
 * @export
 * @interface BlocksApiInterface
 */

/**
 * 
 */
export var BlocksApi = /*#__PURE__*/function (_runtime$BaseAPI) {
  function BlocksApi() {
    _classCallCheck(this, BlocksApi);
    return _callSuper(this, BlocksApi, arguments);
  }
  _inherits(BlocksApi, _runtime$BaseAPI);
  return _createClass(BlocksApi, [{
    key: "createBlockRaw",
    value: (
    /**
     * Adds a block to a view and zone.
     * Add a block to a view
     */
    function () {
      var _createBlockRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestParameters, initOverrides) {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              queryParameters = {};
              headerParameters = {};
              headerParameters['Content-Type'] = 'application/json';
              if (requestParameters['xBffCsrf'] != null) {
                headerParameters['x-bff-csrf'] = String(requestParameters['xBffCsrf']);
              }
              if (!(this.configuration && this.configuration.accessToken)) {
                _context.next = 8;
                break;
              }
              _context.next = 7;
              return this.configuration.accessToken("OAuth2-Test", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 7:
              headerParameters["Authorization"] = _context.sent;
            case 8:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context.next = 12;
                break;
              }
              _context.next = 11;
              return this.configuration.accessToken("OAuth2-Stage", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 11:
              headerParameters["Authorization"] = _context.sent;
            case 12:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context.next = 16;
                break;
              }
              _context.next = 15;
              return this.configuration.accessToken("OAuth2-Prod", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.packaging"]);
            case 15:
              headerParameters["Authorization"] = _context.sent;
            case 16:
              _context.next = 18;
              return this.request({
                path: "/views/blocks",
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AddBlockToViewToJSON(requestParameters['addBlockToView'])
              }, initOverrides);
            case 18:
              response = _context.sent;
              return _context.abrupt("return", new runtime.JSONApiResponse(response, function (jsonValue) {
                return BlockFromJSON(jsonValue);
              }));
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createBlockRaw(_x, _x2) {
        return _createBlockRaw.apply(this, arguments);
      }
      return createBlockRaw;
    }()
    /**
     * Adds a block to a view and zone.
     * Add a block to a view
     */
    )
  }, {
    key: "createBlock",
    value: (function () {
      var _createBlock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var requestParameters,
          initOverrides,
          response,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              requestParameters = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              initOverrides = _args2.length > 1 ? _args2[1] : undefined;
              _context2.next = 4;
              return this.createBlockRaw(requestParameters, initOverrides);
            case 4:
              response = _context2.sent;
              _context2.next = 7;
              return response.value();
            case 7:
              return _context2.abrupt("return", _context2.sent);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createBlock() {
        return _createBlock.apply(this, arguments);
      }
      return createBlock;
    }()
    /**
     * Removes a block from a view.
     * Remove a block from a view
     */
    )
  }, {
    key: "deleteBlockRaw",
    value: (function () {
      var _deleteBlockRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(requestParameters, initOverrides) {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(requestParameters['encodedBlockRID'] == null)) {
                _context3.next = 2;
                break;
              }
              throw new runtime.RequiredError('encodedBlockRID', 'Required parameter "encodedBlockRID" was null or undefined when calling deleteBlock().');
            case 2:
              queryParameters = {};
              headerParameters = {};
              if (requestParameters['xBffCsrf'] != null) {
                headerParameters['x-bff-csrf'] = String(requestParameters['xBffCsrf']);
              }
              if (!(this.configuration && this.configuration.accessToken)) {
                _context3.next = 9;
                break;
              }
              _context3.next = 8;
              return this.configuration.accessToken("OAuth2-Test", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 8:
              headerParameters["Authorization"] = _context3.sent;
            case 9:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context3.next = 13;
                break;
              }
              _context3.next = 12;
              return this.configuration.accessToken("OAuth2-Stage", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 12:
              headerParameters["Authorization"] = _context3.sent;
            case 13:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context3.next = 17;
                break;
              }
              _context3.next = 16;
              return this.configuration.accessToken("OAuth2-Prod", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.packaging"]);
            case 16:
              headerParameters["Authorization"] = _context3.sent;
            case 17:
              _context3.next = 19;
              return this.request({
                path: "/views/blocks/{encodedBlockRID}".replace("{".concat("encodedBlockRID", "}"), encodeURIComponent(String(requestParameters['encodedBlockRID']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters
              }, initOverrides);
            case 19:
              response = _context3.sent;
              return _context3.abrupt("return", new runtime.VoidApiResponse(response));
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deleteBlockRaw(_x3, _x4) {
        return _deleteBlockRaw.apply(this, arguments);
      }
      return deleteBlockRaw;
    }()
    /**
     * Removes a block from a view.
     * Remove a block from a view
     */
    )
  }, {
    key: "deleteBlock",
    value: (function () {
      var _deleteBlock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(requestParameters, initOverrides) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.deleteBlockRaw(requestParameters, initOverrides);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function deleteBlock(_x5, _x6) {
        return _deleteBlock.apply(this, arguments);
      }
      return deleteBlock;
    }()
    /**
     * Authorizes that the user is allowed to modify the view and replaces block parameters for the specified block.
     * Replace a block\'s parameters
     */
    )
  }, {
    key: "replaceBlockParametersRaw",
    value: (function () {
      var _replaceBlockParametersRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(requestParameters, initOverrides) {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(requestParameters['encodedBlockRID'] == null)) {
                _context5.next = 2;
                break;
              }
              throw new runtime.RequiredError('encodedBlockRID', 'Required parameter "encodedBlockRID" was null or undefined when calling replaceBlockParameters().');
            case 2:
              queryParameters = {};
              headerParameters = {};
              headerParameters['Content-Type'] = 'application/json';
              if (requestParameters['xBffCsrf'] != null) {
                headerParameters['x-bff-csrf'] = String(requestParameters['xBffCsrf']);
              }
              if (!(this.configuration && this.configuration.accessToken)) {
                _context5.next = 10;
                break;
              }
              _context5.next = 9;
              return this.configuration.accessToken("OAuth2-Test", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 9:
              headerParameters["Authorization"] = _context5.sent;
            case 10:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context5.next = 14;
                break;
              }
              _context5.next = 13;
              return this.configuration.accessToken("OAuth2-Stage", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 13:
              headerParameters["Authorization"] = _context5.sent;
            case 14:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context5.next = 18;
                break;
              }
              _context5.next = 17;
              return this.configuration.accessToken("OAuth2-Prod", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.packaging"]);
            case 17:
              headerParameters["Authorization"] = _context5.sent;
            case 18:
              _context5.next = 20;
              return this.request({
                path: "/views/blocks/{encodedBlockRID}/blockParameters".replace("{".concat("encodedBlockRID", "}"), encodeURIComponent(String(requestParameters['encodedBlockRID']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ReplaceBlockParametersPayloadToJSON(requestParameters['replaceBlockParametersPayload'])
              }, initOverrides);
            case 20:
              response = _context5.sent;
              return _context5.abrupt("return", new runtime.VoidApiResponse(response));
            case 22:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function replaceBlockParametersRaw(_x7, _x8) {
        return _replaceBlockParametersRaw.apply(this, arguments);
      }
      return replaceBlockParametersRaw;
    }()
    /**
     * Authorizes that the user is allowed to modify the view and replaces block parameters for the specified block.
     * Replace a block\'s parameters
     */
    )
  }, {
    key: "replaceBlockParameters",
    value: (function () {
      var _replaceBlockParameters = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(requestParameters, initOverrides) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.replaceBlockParametersRaw(requestParameters, initOverrides);
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function replaceBlockParameters(_x9, _x10) {
        return _replaceBlockParameters.apply(this, arguments);
      }
      return replaceBlockParameters;
    }()
    /**
     * Authorizes that the user is able to modify the view and replaces the block.
     * Updates the block entirely
     */
    )
  }, {
    key: "updateBlockRaw",
    value: (function () {
      var _updateBlockRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(requestParameters, initOverrides) {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(requestParameters['encodedBlockRID'] == null)) {
                _context7.next = 2;
                break;
              }
              throw new runtime.RequiredError('encodedBlockRID', 'Required parameter "encodedBlockRID" was null or undefined when calling updateBlock().');
            case 2:
              queryParameters = {};
              headerParameters = {};
              headerParameters['Content-Type'] = 'application/json';
              if (requestParameters['xBffCsrf'] != null) {
                headerParameters['x-bff-csrf'] = String(requestParameters['xBffCsrf']);
              }
              if (!(this.configuration && this.configuration.accessToken)) {
                _context7.next = 10;
                break;
              }
              _context7.next = 9;
              return this.configuration.accessToken("OAuth2-Test", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 9:
              headerParameters["Authorization"] = _context7.sent;
            case 10:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context7.next = 14;
                break;
              }
              _context7.next = 13;
              return this.configuration.accessToken("OAuth2-Stage", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 13:
              headerParameters["Authorization"] = _context7.sent;
            case 14:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context7.next = 18;
                break;
              }
              _context7.next = 17;
              return this.configuration.accessToken("OAuth2-Prod", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.packaging"]);
            case 17:
              headerParameters["Authorization"] = _context7.sent;
            case 18:
              _context7.next = 20;
              return this.request({
                path: "/views/blocks/{encodedBlockRID}".replace("{".concat("encodedBlockRID", "}"), encodeURIComponent(String(requestParameters['encodedBlockRID']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateBlockInViewToJSON(requestParameters['updateBlockInView'])
              }, initOverrides);
            case 20:
              response = _context7.sent;
              return _context7.abrupt("return", new runtime.VoidApiResponse(response));
            case 22:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function updateBlockRaw(_x11, _x12) {
        return _updateBlockRaw.apply(this, arguments);
      }
      return updateBlockRaw;
    }()
    /**
     * Authorizes that the user is able to modify the view and replaces the block.
     * Updates the block entirely
     */
    )
  }, {
    key: "updateBlock",
    value: (function () {
      var _updateBlock = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(requestParameters, initOverrides) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.updateBlockRaw(requestParameters, initOverrides);
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function updateBlock(_x13, _x14) {
        return _updateBlock.apply(this, arguments);
      }
      return updateBlock;
    }())
  }]);
}(runtime.BaseAPI);